/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/img/credibled_logo_205x45.png';

const ClientAdminLayout = () => {
	const currLink = useLocation().pathname;
	const baseLink = currLink.split('/')[1];
	return (
		<>
			<div
				className='sidebar'
				data-color='purple'
				data-background-color='white'
			>
				<div className='logo text-center'>
					<Link
						className='navbar-brand'
						to={`/${baseLink}/users`}
					>
						<img
							src={logo}
							alt='Credibled Logo'
						/>
					</Link>
					<h4 className='text-secondary'>Client Admin</h4>
				</div>

				<div className='sidebar-wrapper'>
					<ul className='nav'>
						<li className='nav-item'>
							<Link
								className='nav-link or_bg'
								to={`/${baseLink}/users/add-new-user`}
							>
								<i className='material-icons txt_white'>post_add</i>

								<span className='new_req'>New </span>
								<span className='new_req'>user</span>
							</Link>
						</li>
						{/* <li className={`nav-item ${currLink.includes('requests')? 'active':null}`}>
            <Link style={{background:"white"}} href="#" class="nav-link dropdown-toggle" data-toggle="collapse" data-target="#sbm" aria-expanded="true">
             <i class="material-icons-outlined">summarize</i> <span>Reports</span>
            </Link>
            <div id="sbm" className="collapse show">
                  <ul className="mfix">
                  <li><Link className={`submenu1 nav-link ${currLink.includes('requests')? 'active1':null}`} to={`/${baseLink}/requests`}>&nbsp;Requests</Link></li>
                  <li><Link className={`submenu1 nav-link ${currLink.includes('submenu2')? 'active1':null}`} to={`/${baseLink}/requests`}>&nbsp;Submenu2</Link></li>
                  <ul>
            </ul></ul></div>
          </li> */}
						<li
							className={`nav-item ${
								currLink.includes('users') ? 'active' : null
							}`}
						>
							<Link
								className={`nav-link ${
									currLink.includes('users') ? 'active1' : null
								}`}
								to={`/${baseLink}/users`}
							>
								<i className='material-icons-outlined'>supervisor_account</i>
								<p>Users</p>
							</Link>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('admins') ? 'active' : null
							}`}
						>
							<Link
								className={`nav-link ${
									currLink.includes('admins') ? 'active1' : null
								}`}
								to={`/${baseLink}/admins`}
							>
								<i className='material-icons-outlined'>manage_accounts</i>
								<p>Admins</p>
							</Link>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('settings') ? 'active' : null
							}`}
						>
							<Link
								className={`nav-link ${
									currLink.includes('settings') ? 'active1' : null
								}`}
								to={`/${baseLink}/settings`}
							>
								<i className='material-icons-outlined'>settings</i>
								<p>Settings</p>
							</Link>
						</li>
					</ul>
				</div>
			</div>
			<footer
				className='footer showonmobile'
				style={{ display: 'none' }}
			>
				<nav className='col-md-12'>
					<ul className='mobile_footer'>
						{/* <li className="nav-item">
                <Link className={`nav-link ${currLink.includes('clients')? 'mobile-active':null}`} to='/client-admin/clients'>
                   <i className="material-icons-outlined">people</i>
                   <p>Clients</p>
                </Link>
             </li> */}
						<li className='nav-item'>
							<Link
								className={`nav-link ${
									currLink.includes('users') ? 'mobile-active' : null
								}`}
								to={`/${baseLink}/users`}
							>
								<i className='material-icons-outlined'>supervisor_account</i>
								<p>Users</p>
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								className={`nav-link ${
									currLink.includes('admins') ? 'mobile-active' : null
								}`}
								to={`/${baseLink}/admins`}
							>
								<i className='material-icons-outlined'>manage_accounts</i>
								<p>Admins</p>
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								className={`nav-link ${
									currLink.includes('settings') ? 'mobile-active' : null
								}`}
								to={`/${baseLink}/settings`}
							>
								<i className='material-icons-outlined'>settings</i>
								<p>Settings</p>
							</Link>
						</li>
						<li className='nav-item dropdown'>
							<Link
								to='#'
								className='nav-link'
								id='footermore'
								data-toggle='dropdown'
								aria-haspopup='true'
								aria-expanded='false'
							>
								<i className='material-icons-outlined'>more_vert</i>
								<p>More</p>
								<div
									className='dropdown-menu'
									aria-labelledby='footermore'
								>
									<Link
										className='dropdown-item'
										to={`$/{baseLink}/users`}
									>
										Reports
									</Link>
								</div>
							</Link>
						</li>
					</ul>
				</nav>
				{/* <!-- your footer here --> */}
			</footer>
		</>
	);
};

export default ClientAdminLayout;
